import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, Cookie } from "lucide-react";

const KEY = "ap_cookie_consent_v1";

export default function CookieBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        try {
            if (!localStorage.getItem(KEY)) setVisible(true);
        } catch {
            // localStorage disabled — fail silent, don't spam the banner
        }
    }, []);

    const accept = () => {
        try { localStorage.setItem(KEY, JSON.stringify({ v: 1, at: new Date().toISOString(), choice: "accept" })); } catch { /* localStorage unavailable */ }
        setVisible(false);
    };
    const decline = () => {
        try { localStorage.setItem(KEY, JSON.stringify({ v: 1, at: new Date().toISOString(), choice: "decline" })); } catch { /* localStorage unavailable */ }
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div
            data-testid="cookie-banner"
            className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-[70]"
        >
            <div className="card p-5 shadow-xl border border-[var(--border)]">
                <div className="flex items-start gap-3">
                    <div className="flex-shrink-0 w-9 h-9 rounded-full bg-[var(--brand-subtle)] flex items-center justify-center">
                        <Cookie size={16} className="text-[var(--brand)]" />
                    </div>
                    <div className="flex-1 min-w-0">
                        <div className="font-display font-bold text-sm text-primary mb-1">Cookies & Privacy</div>
                        <p className="text-xs text-secondary leading-relaxed">
                            We use strictly-necessary cookies to keep you signed in and your cart intact. No third-party
                            trackers, no ad networks. Read our{" "}
                            <Link to="/privacy" className="text-[var(--brand)] underline">Privacy Policy</Link>.
                        </p>
                        <div className="flex items-center gap-2 mt-4">
                            <button onClick={accept} className="btn btn-solid text-xs" data-testid="cookie-accept">Accept</button>
                            <button onClick={decline} className="btn text-xs" data-testid="cookie-decline">Decline</button>
                        </div>
                    </div>
                    <button
                        onClick={decline}
                        aria-label="Close"
                        className="flex-shrink-0 text-muted hover:text-primary"
                        data-testid="cookie-close"
                    >
                        <X size={16} />
                    </button>
                </div>
            </div>
        </div>
    );
}
